import { ICitationPermissions } from '@vivli/shared/features/citations/infrastructure/interface';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { useMemo } from 'react';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export const useCitationPermissionsHook = (isDisclosure = false): ICitationPermissions => {
    const { user, hasPermission } = useActiveUserContext();

    const isVivliAdmin = useMemo(() => {
        if (!user) {
            return false;
        }

        return hasPermission(PermissionsEnum.DrActAdv);
    }, [user]);

    return {
        user,
        canAddCitation: isVivliAdmin,
        canEditPublishedDate: isVivliAdmin,
        canViewPublishedDate: isDisclosure,
        canModifyCitation: isVivliAdmin,
        canDeleteCitation: isVivliAdmin,
    };
};
